import type { CmsItem } from '~/types/cms';

export async function useLocationPage() {
    const route = useRoute();
    const { locales } = useI18n();
    const siteId = useSiteId();
    const routeSlug = String(route.params.slug ?? '');
    const localeList = locales.value as { code: string; craftSiteId?: number; language?: string }[];

    const { entry, status } = await fetchLocationEntry(routeSlug, localeList, siteId);
    const locationData = computed<CmsItem>(() => entry ?? {});

    if (entry) {
        const i18nParams = applyLocationI18nParams(entry, localeList);

        route.meta.nuxtI18n = i18nParams;
        usePageSettings(entry.typeHandle, entry.sectionHandle);
        useSeoData(entry.seo);
    } else {
        throw createError({ statusCode: 404, statusMessage: 'Page Not Found' });
    }

    return { locationData, status };
}
